import {PAGE_TARNSALATION_KEYS} from './pageConfig';

const CATEGORY = 'messages';
const MessageReader = require('@homeaway/stab-message-reader');

if (typeof require.ensure !== 'function') {
    require.ensure = (d, c) => c(require);
}

export const I18n = {
    /**
     * Loads messages file
     * @param locale lang name to use as suffix to resolve file path
     * @returns Promise resolved when language file has been loaded
     */
    load(locale) {
        MessageReader.setLocale(locale);
        return new Promise((resolve) =>
            require.ensure(
                [],
                () => resolve(require(`../../../resources/compiled/${locale}`))
            )
        );
    },
    /**
     * Read a message via a key and variable options object
     * @param key String
     * @param options Object containing name/value pairs
     * @category lingua key category
     */
    read(key, options, category) {
        return MessageReader.read(key, options, category);
    },
    /**
     * Read a message if it exists via a key and variable options object
     * @param key String
     * @param options Object containing name/value pairs
     * @category lingua key category
     */
    readIfExists(key, options, category) {
        if (typeof category === 'undefined') {
            category = CATEGORY;
        }
        return this.exists(key) ? this.read(key, options, category) : null;
    },
    /**
     * Determine if a key is supported for the current locale
     * @param key String
     * @return keyExists Boolean
     */
    exists(key) {
        return MessageReader.exists(key, CATEGORY);
    },
};


export const readTransalationsBundles = function(page, options) {
    const bundles = Object.assign(PAGE_TARNSALATION_KEYS[page], PAGE_TARNSALATION_KEYS.common);
    let transBundles = {};
    Object.keys(bundles).forEach((val) => {
        transBundles[val] = I18n.readIfExists(bundles[val], options);
    });
    return transBundles;
};
export const readTranslations = function(page, options, key) {
    if (typeof page === 'undefined') {
        page = 'common';
    }
    const keys = PAGE_TARNSALATION_KEYS[page];
    return I18n.readIfExists(keys[key], options);
};
